<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRPolice1 }}</h2>
        <div class="mb-3">
            {{ store.lexicon[store.culture].PRPolice2 }}
        </div>
        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice3 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Police.CaseNumber" @@blur="updateCaseNumber" />
            </div>
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice3a }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Police.PersonInvolvedName" @input="validatePage('Police', 'personInvolvedName')" />
                <div v-if="store.errors.Police.PersonInvolvedName" class="error">{{ store.lexicon[store.culture].PRPolice4 }}</div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice5 }} <span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Police.PersonInvolvedDob" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy" @update:model-value="validatePage('Police', 'personInvolvedDob')"></VueDatePicker>
                <!--<bootstrap-datetime-picker :options="dtPickerOptions" v-model="store.formData.Police.PersonInvolvedDob" @@input="validatePage('Police', 'personInvolvedDob')"></bootstrap-datetime-picker>-->
                <div v-if="store.errors.Police.PersonInvolvedDob" class="error">{{ store.lexicon[store.culture].PRPolice6 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice7 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Police.PersonInvolvedRelation" @input="validatePage('Police', 'personInvolvedRelation')" />
                <div v-if="store.errors.Police.PersonInvolvedRelation" class="error">{{ store.lexicon[store.culture].PRPolice8 }}</div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice9 }} <span class="required">*</span></label>
                <VueDatePicker v-model="store.formData.Police.IncidentDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy" @update:model-value="validatePage('Police', 'IncidentDate')"></VueDatePicker>
                <!--<bootstrap-datetime-picker :options="dtPickerOptions" v-model="store.formData.Police.IncidentDate"></bootstrap-datetime-picker>-->
                <div v-if="store.errors.Police.IncidentDate" class="error">{{ store.lexicon[store.culture].PRPolice10 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice11 }}</label>
                <input type="text" class="form-control" v-model="store.formData.Police.IncidentTime" @@blur="updateTimeOfIncident" />
            </div>
        </div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRPolice12 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Police.IncidentLocation" @input="validatePage('Police', 'incidentLocation')" />
                <div v-if="store.errors.Police.IncidentLocation" class="error">{{ store.lexicon[store.culture].PRPolice13 }}</div>
            </div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRPolice14 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Police.Details" @input="validatePage('Police', 'details')"></textarea>
            <div v-if="store.errors.Police.Details" class="error">{{ store.lexicon[store.culture].PRPolice15 }}</div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage', 'validatePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }


</script>